import { library, dom } from '@fortawesome/fontawesome-svg-core';

// Brands (met _b achter de naam).
import { faFacebookF as faFacebookF_b } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram as faInstagram_b } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin as faLinkedin_b } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faTwitter as faTwitter_b } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faWhatsapp as faWhatsapp_b } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faYoutube as faYoutube_b } from '@fortawesome/free-brands-svg-icons/faYoutube';

// Light (met _l achter de naam).
import { faCalendar as faCalendar_l } from '@fortawesome/pro-light-svg-icons/faCalendar';
import { faCaretRight as faCaretRight_l } from '@fortawesome/pro-light-svg-icons/faCaretRight';
import { faCircle as faCircle_l } from '@fortawesome/pro-light-svg-icons/faCircle';
import { faInfo as faInfo_l } from '@fortawesome/pro-light-svg-icons/faInfo';
import { faNewspaper as faNewspaper_l } from '@fortawesome/pro-light-svg-icons/faNewspaper';
import { faQuestion as faQuestion_l } from '@fortawesome/pro-light-svg-icons/faQuestion';
import { faThumbsUp as faThumbsUp_l } from '@fortawesome/pro-light-svg-icons/faThumbsUp';
import { faAngleRight  as faAngleRight_l } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { faCaretCircleRight as faCaretCircleRight_l } from '@fortawesome/pro-regular-svg-icons/faCaretCircleRight';
import { faChevronCircleRight as faChevronCircleRight_l } from '@fortawesome/pro-regular-svg-icons/faChevronCircleRight';


// Regular (met _r achter de naam).
import { faCalendarAlt as faCalendarAlt_r } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faCheckCircle as faCheckCircle_r } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faClock as faClock_r } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faEnvelope as faEnvelope_r } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faFolderOpen as faFolderOpen_r } from '@fortawesome/pro-regular-svg-icons/faFolderOpen';
import { faHome as faHome_r } from '@fortawesome/pro-regular-svg-icons/faHome';
import { faMapMarkerAlt as faMapMarkerAlt_r } from '@fortawesome/pro-regular-svg-icons/faMapMarkerAlt';
import { faMobile as faMobile_r } from '@fortawesome/pro-regular-svg-icons/faMobile';
import { faPenFancy as faPenFancy_r } from '@fortawesome/pro-regular-svg-icons/faPenFancy';
import { faPlusCircle as faPlusCircle_r } from '@fortawesome/pro-regular-svg-icons/faPlusCircle';
import { faPhone as faPhone_r } from '@fortawesome/pro-regular-svg-icons/faPhone';
import { faQuestionCircle as faQuestionCircle_r } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';
import { faSearch as faSearch_r } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faShoppingCart as faShoppingCart_r } from '@fortawesome/pro-regular-svg-icons/faShoppingCart';
import { faSignInAlt as faSignInAlt_r } from '@fortawesome/pro-regular-svg-icons/faSignInAlt';
import { faSmile as faSmile_r } from '@fortawesome/pro-regular-svg-icons/faSmile';
import { faStar as faStar_r } from '@fortawesome/pro-regular-svg-icons/faStar';
import { faTags as faTags_r } from '@fortawesome/pro-regular-svg-icons/faTags';
import { faTrophy as faTrophy_r } from '@fortawesome/pro-regular-svg-icons/faTrophy';
import { faUser as faUser_r } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faUsers as faUsers_r } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faPersonDolly as faPersonDolly_r } from '@fortawesome/pro-regular-svg-icons/faPersonDolly';
import { faAddressCard as faAddressCard_r } from '@fortawesome/pro-regular-svg-icons/faAddressCard';
import { faCaretCircleRight as faCaretCircleRight_r } from '@fortawesome/pro-regular-svg-icons/faCaretCircleRight';
import { faStopwatch as faStopwatch_r } from '@fortawesome/pro-regular-svg-icons/faStopwatch';



// Solid (met _s achter de naam).
import { faAngleRight as faAngleRight_s } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faAngleDown as faAngleDown_s } from '@fortawesome/pro-solid-svg-icons/faAngleDown';
import { faArrowAltRight as faArrowAltRight_s } from '@fortawesome/pro-solid-svg-icons/faArrowAltRight';
import { faArrowDown as faArrowDown_s } from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import { faArrowUp as faArrowUp_s } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faCheck as faCheck_s } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle as faCheckCircle_s } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faChevronLeft as faChevronLeft_s } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight as faChevronRight_s } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faCircle as faCircle_s } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faEnvelope as faEnvelope_s } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faPhone as faPhone_s } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faQuestionCircle as faQuestionCircle_s } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faQuoteLeft as faQuoteLeft_s } from '@fortawesome/pro-solid-svg-icons/faQuoteLeft';
import { faQuoteRight as faQuoteRight_s } from '@fortawesome/pro-solid-svg-icons/faQuoteRight';
import { faSignInAlt as faSignInAlt_s } from '@fortawesome/pro-solid-svg-icons/faSignInAlt';
import { faStar as faStar_s } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStarHalf as faStarHalf_s } from '@fortawesome/pro-solid-svg-icons/faStarHalf';
import { faSquare as faSquare_s } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { faChevronCircleRight as faChevronCircleRight_s } from '@fortawesome/pro-solid-svg-icons/faChevronCircleRight';
import { faLevelDownAlt as faLevelDownAlt_s } from '@fortawesome/pro-solid-svg-icons/faLevelDownAlt';

library.add(
	faFacebookF_b,
	faInstagram_b,
	faLinkedin_b,
	faTwitter_b,
	faWhatsapp_b,
	faYoutube_b,
	faCalendar_l,
	faCaretRight_l,
	faAngleRight_l,
	faCircle_l,
	faInfo_l,
	faNewspaper_l,
	faQuestion_l,
	faThumbsUp_l,
	faCaretCircleRight_l,
	faChevronCircleRight_l,
	faCalendarAlt_r,
	faCheckCircle_r,
	faClock_r,
	faEnvelope_r,
	faFolderOpen_r,
	faHome_r,
	faMapMarkerAlt_r,
	faMobile_r,
	faPenFancy_r,
	faPlusCircle_r,
	faPhone_r,
	faQuestionCircle_r,
	faSearch_r,
	faShoppingCart_r,
	faSignInAlt_r,
	faSmile_r,
	faStar_r,
	faTags_r,
	faTrophy_r,
	faUser_r,
	faUsers_r,
	faPersonDolly_r,
	faAddressCard_r,
	faCaretCircleRight_r,
	faStopwatch_r,
	faAngleRight_s,
	faAngleDown_s,
	faArrowAltRight_s,
	faArrowDown_s,
	faArrowUp_s,
	faCheck_s,
	faCheckCircle_s,
	faChevronLeft_s,
	faChevronRight_s,
	faChevronCircleRight_s,
	faCircle_s,
	faSquare_s,
	faPhone_s,
	faEnvelope_s,
	faQuestionCircle_s,
	faQuoteLeft_s,
	faQuoteRight_s,
	faSignInAlt_s,
	faStar_s,
	faStarHalf_s,
	faLevelDownAlt_s
);

// Kicks off the process of finding <i> tags and replacing with <svg>.
dom.watch();
